import { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import {
  Row,
  Col,
  Container,
  Card,
  Heading,
  Text,
  Stack,
  useModal
} from '@leroy-merlin-br/backyard-react-ui'

import DocumentPro from 'scripts/react-components/lmcv-pro/components/DocumentPro'

import { CardHeader } from 'lmcv/components/Card'
import handleModal from 'lmcv/pages/Customers/handleModal'
import * as loyaltyStatus from 'lmcv/modules/LoyaltyStatus/constants'

import { TimeLine } from './components/TimeLine'
import { TimeLineItem } from './components/TimeLineItem'
import * as S from './styled'
import { STATUS_DATA } from '../../constants/statusData'

const DocumentStatus = ({
  status,
  hasProfessionalRelationship,
  professionalData
}) => {
  const { setModal } = useModal()

  const [drawerVisibility, setDrawerVisibility] = useState(false)
  const isNotEligibleToEAD = status === 11 && hasProfessionalRelationship

  const showDrawer = () => {
    isNotEligibleToEAD
      ? handleModal(setModal)
      : setDrawerVisibility(true)
  }

  const closeDrawer = () => setDrawerVisibility(false)

  const onSubmit = () => document.location.reload()

  const onCatch = () => {
    closeDrawer()
    handleModal(setModal)
  }

  const title =
    status === loyaltyStatus.PRO_EAD_DOCUMENTATION_DENIED
      ? 'Seu documento não foi aprovado'
      : 'Seu documento precisa ser validado para acessar essa área'

  const hasUploadDate = professionalData?.documentation?.uplodedAt

  const uploadAtFormatted = hasUploadDate
    ? `
    Enviado dia
    ${dayjs(uplodedAt).format('DD/MM/YYYY')}
  `
    : 'Enviado!'

  return (
    <Fragment>
      <Card>
        <CardHeader title="Clientes" />

        <S.Body>
          <Heading size="tera" noMargin>
            {title}
          </Heading>

          <TimeLine status={status}>
            <TimeLineItem icon="checked" status={loyaltyStatus.PRO_EAD_ACTIVE}>
              {uploadAtFormatted}
            </TimeLineItem>

            <TimeLineItem icon="clock" status={loyaltyStatus.PRO_EAD_ACTIVE}>
              Em análise
            </TimeLineItem>

            <TimeLineItem status={status}>
              {STATUS_DATA[status].iconText}
            </TimeLineItem>
          </TimeLine>

          {status ===
            loyaltyStatus.PRO_EAD_WAITING_DOCUMENTATION_VALIDATION && (
            <Text noMargin size="kilo">
              {STATUS_DATA['8'].text}
            </Text>
          )}

          {status === loyaltyStatus.PRO_EAD_DOCUMENTATION_DENIED && (
            <Stack spacing="bit">
              <Text noMargin size="kilo" bold>
                Motivo da reprovação:
              </Text>
              <Text noMargin size="kilo">
                {professionalData &&
                  professionalData.documentation.rejectionReason}
              </Text>
            </Stack>
          )}

          {status === loyaltyStatus.PRO_EAD_DOCUMENTATION_DENIED && (
            <Container>
              <Row justify="center">
                <Col size={{ giga: 4 }}>
                  <S.Button
                    onClick={showDrawer}
                    color="green"
                    isStretch
                    size="mega"
                  >
                    Reenviar Documentos
                  </S.Button>
                </Col>
              </Row>
            </Container>
          )}
        </S.Body>
      </Card>

      <DocumentPro
        open={drawerVisibility}
        onClose={closeDrawer}
        onCancel={closeDrawer}
        onFinish={onSubmit}
        onCatch={onCatch}
      />
    </Fragment>
  )
}

DocumentStatus.propTypes = {
  status: PropTypes.number,
  hasProfessionalRelationship: PropTypes.bool,
  professionalData: PropTypes.object
}

export default DocumentStatus
